export enum LogoType {
  SVG = 'svg',
  Image = 'img',
}

/** The configuration for the logo component */
export type ILogoConfig = ILogoSvgConfig | ILogoImageConfig | string;

export interface ILogoSvgConfig {
  src: string;
  alt: string;
  type: LogoType.SVG;
  link?: string;
  rel?: string;
  linkTarget?: string;
}

export interface ILogoImageConfig {
  src: string;
  alt: string;
  type: LogoType.Image;
  link?: string;
  linkTarget?: string;
  rel?: string;
}
